module.exports = __webpack_public_path__ + "img/logo7.15445f17.jpeg";